import { action } from 'easy-peasy';

import { IActionSetSelectedMarkerId } from '../types';

const setSelectedMarkerId: IActionSetSelectedMarkerId = action((state, payload) => {
  state.selectedMarkerId = payload;
});

export default setSelectedMarkerId;
